import {EnglishService} from '../languages/english.service';
import {GermanService} from '../languages/german.service';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Subject} from 'rxjs/Subject';
import { ItalianService } from '../languages/italian.service';

// #########################################################################
//
// This service is used to keep track of all information about the language
// so we keep track of the following thing and provide an interface to access
// those information from a component:
//      - language
//      - language abbreviation
//      
// There are specific Language Services (EnglishService and GermanService)
// Which keep the information to be filled into the hashtables when we set the
// system language. In general we use hasmaps with the same keys, and so we can
// exchange the actual hashmap dynamically
//
// #########################################################################

export class LanguageService {

  private lang = new Array();
  private languageAbbreviation;
  
  public space: Subject<string> = new BehaviorSubject<string>(this.lang['enterCommand']);
  
  constructor() {
    
    // depending on system language load different language service
    let systemLanguage = navigator.language.slice(0, 2);
    
    let languageService;
    switch (systemLanguage) {
      case 'en':
        languageService = new EnglishService();
        this.languageAbbreviation = 'en';
        break;
      case 'de':
        languageService = new GermanService();
        this.languageAbbreviation = 'de';
        break;
      case 'it':
        languageService = new ItalianService();
        this.languageAbbreviation = 'it';
      default:
        languageService = new EnglishService();
        this.languageAbbreviation = 'en';
    }
    this.lang = languageService.getLang();

    // detect system language
    this.lang = this.getLang();
  }

  public translateKey(word:string): string{
    return this.lang[word];
  }

  public getLang() {
    return this.lang;
  }

  public setLang(lang) {
    this.lang = lang;
  }

  public getLangAbbrev() {
    return this.languageAbbreviation;
  }

  //###################################################################################
  //TODO: these functions are dummies to make project compile. Needs proper integration work later on
  //###################################################################################

  public setHeaderText(text){
    this.lang["XLogoOnline"] = text;
  }

  public setHeadLineTextTo(text: string, color: string): void {
    //set new text value and color 
    if (document.getElementById("headerText") != null) {
      document.getElementById("headerText").style.color = color;
      document.getElementById("headerText").textContent = text;
    }
	}

}



// WEBPACK FOOTER //
// ./src/app/services/language.service.ts